var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { Subject } from 'rxjs';
import { getUserModel } from './userModel';
let ManageController = class ManageController {
    constructor() {
        /**
         * 用户信息
         * @memberof SystemController
         */
        this.User = getUserModel();
        this.Auth = {};
        /**
         * 用户异步数据加载订阅
         * @type {Promise<any>}
         * @memberof ControllerUser
         */
        this.UserSubject = new Subject();
    }
    /**
     * token
     * @readonly
     * @memberof SystemController
     */
    get AccessToken() {
        return lodash.get(this.User.value, 'token');
    }
    /**
     * 登陆状态
     * @readonly
     * @memberof SystemController
     */
    get LoggedIn() {
        return !lodash.isEmpty(this.AccessToken);
    }
    /**
     * 重置 Token
     */
    resetToken(token) {
        if (token) {
            this.User.merge({ token });
        }
    }
    /**
     * 解析地址栏携带的登陆信息
     * @memberof SystemController
     */
    async onParseQueryToken(query) {
        if (lodash.hasIn(query, 'token')) {
            const token = lodash.get(query, 'token');
            await this.User.HydrateAsync;
            this.User.merge({ token });
        }
    }
    /**
     * 校验登陆状态
     * @memberof SystemController
     */
    async onVerify() {
        await this.onGetUserInfo();
    }
    /**
     * 获取用户信息
     * @returns
     */
    async onGetUserInfo() {
        if (lodash.isEmpty(this.AccessToken)) {
            this.UserSubject.complete();
            this.User.toggleLoading(false);
            return;
        }
        this.UserSubject.complete();
        this.User.toggleLoading(false);
        return;
    }
    /**
     * 退出登录
     * @return {*}
     * @memberof SystemController
     */
    async onLoginOut() {
        this.User.set({});
        return true;
    }
    /**
     * 检查用户是否登陆
     * @return {*}
     * @memberof SystemController
     */
    onInspectUser() {
        if (this.LoggedIn) {
            return this.User.value;
        }
        throw '未登录';
    }
};
__decorate([
    computed
], ManageController.prototype, "AccessToken", null);
__decorate([
    computed
], ManageController.prototype, "LoggedIn", null);
ManageController = __decorate([
    BindAll()
], ManageController);
export { ManageController };
